import { render, staticRenderFns } from "./account_add.vue?vue&type=template&id=d121eafe&scoped=true&"
import script from "./account_add.vue?vue&type=script&lang=js&"
export * from "./account_add.vue?vue&type=script&lang=js&"
import style0 from "./account_add.vue?vue&type=style&index=0&id=d121eafe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d121eafe",
  null
  
)

export default component.exports